import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/utils/utils"
import { DISABLED, FOCUS } from "@/components/ui/recipes"

/**
 * Lureo's switch: the theme's on and off fills, an edge when off where the theme draws one, and its knob on and off; sm in
 * a lane's small header (the timeline's Triggers); tone trigger fills it, when on, in the triggers' violet beside their marks.
 */
const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & { size?: "md" | "sm"; tone?: "brand" | "trigger" }
>(({ className, size = "md", tone = "brand", ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex shrink-0 cursor-pointer items-center rounded-lureo-radius-pill transition-colors data-[state=unchecked]:bg-lureo-switch-off data-[state=unchecked]:shadow-lureo-shadow-switch-off",
      tone === "trigger" ? "data-[state=checked]:bg-lureo-violet" : "data-[state=checked]:bg-lureo-switch-on",
      size === "sm" ? "h-3.5 w-6" : "h-5 w-9",
      FOCUS,
      DISABLED,
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block rounded-full bg-lureo-switch-thumb shadow-lureo-shadow-control transition-[translate,background-color] data-[state=unchecked]:translate-x-0.5",
        tone === "trigger" ? "data-[state=checked]:bg-lureo-on-violet" : "data-[state=checked]:bg-lureo-switch-thumb-on",
        size === "sm" ? "h-2.5 w-2.5 data-[state=checked]:translate-x-3" : "h-4 w-4 data-[state=checked]:translate-x-4.5"
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
